export default {
  props: {
    contentCss: {
      type: String,
    },
    contentHtml: {
      type: String,
    },
  },
  methods: {
    async initContent(editor) {
      if (this.contentCss) {
        editor.setStyle(this.contentCss);
      }
      if (this.contentHtml) {
        function decodeHtml(html) {
          const textarea = document.createElement("textarea");
          textarea.innerHTML = html;
          textarea.value = textarea.value.replace(/<(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)([^>]*?)(?<!\/)>/gi, '<$1$2 />');
          return textarea.value;
        }
        editor.setComponents(decodeHtml(this.contentHtml));
      }
      editor.on('update', () => {
        if ('web' === this.project) {
          this.$emit('contentCssUpdated', editor.getCss());
          this.$emit('contentHtmlUpdated', editor.getHtml());
        } else {
          this.$emit('contentHtmlUpdated', editor.Commands.run('gjs-get-inlined-html'));
        }
      });
    }
  }
}
